import React from "react"

import Layout from "../components/allstar/layout"

import SectionBody from "../components/allstar/methodology/section-body"
import { graphql } from "gatsby"

const ResourceMethodologyPage = props => {
  return (
    <Layout location={props.location} title={"Methodology"} isResourceSite>
      <SectionBody data={props.data} />
    </Layout>
  )
}

export default ResourceMethodologyPage

export const query = graphql`
  query resourceMethodologyPage {
    allBadges: allFile(
      filter: { relativeDirectory: { eq: "allstar/badges" } }
    ) {
      edges {
        node {
          name
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`
